var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavStar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "star",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.8,1.074l1.32,2.64a1.63,1.63,0,0,0,1.065.788l2.392.4c1.53.255,1.89,1.365.787,2.46L12.5,9.219a1.628,1.628,0,0,0-.39,1.358l.533,2.3c.42,1.822-.548,2.528-2.16,1.575L8.242,13.127a1.621,1.621,0,0,0-1.485,0L4.514,14.454c-1.605.953-2.58.24-2.16-1.575l.533-2.3A1.628,1.628,0,0,0,2.5,9.219L.637,7.359c-1.095-1.095-.742-2.2.788-2.46l2.392-.4a1.633,1.633,0,0,0,1.057-.788l1.32-2.64C6.914-.358,8.084-.358,8.8,1.074Z",
    transform: "translate(1.501 1.558)",
    fill: "#ffe600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M0,0H18V18H0Z",
    fill: "none",
    opacity: 0
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavStar);
export default __webpack_public_path__ + "static/media/fav-star.3c35ad6ca128606ccf42ddc3320baa84.svg";
export { ForwardRef as ReactComponent };